// extracted by mini-css-extract-plugin
module.exports = {"root":"inviteTitle_root__AOXiT","headerIteam":"inviteTitle_headerIteam__WQC9G"};